import styled from 'styled-components';
import { motion } from 'framer-motion';

export const ProfileWrapper = styled.div`
  position: relative;
`
export const HeaderProfilePillContainer = styled.div`
  align-items: center;
  border: 2px solid rgb(255, 255, 255, 0.33);
  border-radius: 50px;
  box-sizing: border-box;
  cursor: pointer;
  display: flex;
  height: 44px;
  position: relative;
  transition: height 0.4s ease-in-out, transform 0.4s, border-radius 0.4s ease-in-out;
  user-select: none;
      -webkit-touch-callout: none;
      -webkit-user-select: none;
      -khtml-user-select: none;
      -moz-user-select: none;
      -ms-user-select: none;

  img {
    border: 2px solid rgb(255, 255, 255, 0.33);
    border-radius: 100px;
    box-sizing: border-box;
    height: 32px;
    margin: 4px;

  }

  h3 {
    color: #FFFFFF;
    font-size: 12px;
    font-weight: 600;
    margin: 0;
    padding-left: 8px;
    padding-right: 16px;
  }
`;
export const DropdownMenu = styled(motion.div)`
  background: transparent;
  border: none;
  box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  position: absolute;
  top: 100%;
  right: 0;
  width: 196px;
  z-index: 100;

  ul {
    background-color: rgba(255,255,255,0.2);
    border-radius: 12px;
    list-style-type: none;
    margin: 0;
    padding: 4px;
    text-align: right;
    border: 1px solid rgba(255, 255, 255, 0.2);
    
    li {
      border-radius: 8px;
      color: #FFFFFF;
      cursor: pointer;
      padding: 12px 16px;
      transition: background-color 0.2s ease-in-out;
      user-select: none;
        -webkit-touch-callout: none;
        -webkit-user-select: none;
        -khtml-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;

      &:hover {
        background-color: rgba(255, 255, 255, 0.1);
      }
    }
  }
`;
export const MenuContent = styled.div`
  background-color: transparent;

  div {
    height: 8px;
  }
`